var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "C",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.12,
    cy: 64,
    fill: "#ee404c",
    r: 45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.1 81.9a5 5 0 0 0 7.12 0l10.78-10.78 10.78 10.78a5 5 0 0 0 7.12-7.12l-10.78-10.78 10.78-10.78a5 5 0 1 0 -7.12-7.12l-10.78 10.78-10.78-10.78a5 5 0 1 0 -7.12 7.12l10.78 10.78-10.78 10.78a5 5 0 0 0 0 7.12z",
    fill: "#fff7ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.fbd1118077f150e60edcf80e6784d769.svg";
export { ForwardRef as ReactComponent };